import { render, staticRenderFns } from "./KBasicContentIcon.vue?vue&type=template&id=6551cf0a&scoped=true&"
import script from "./KBasicContentIcon.vue?vue&type=script&lang=js&"
export * from "./KBasicContentIcon.vue?vue&type=script&lang=js&"
import style0 from "./KBasicContentIcon.vue?vue&type=style&index=0&id=6551cf0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6551cf0a",
  null
  
)

component.options.__file = "KBasicContentIcon.vue"
export default component.exports